<template>
  <RequestForm
    :model="matcherRequest"
    submit-button-text="Anfrage bearbeiten"
    @submit="submit"
    @favouriteAdded="addFavourite"
    @favouriteRemoved="removeFavourite"
  />
</template>

<script>
import gql from "graphql-tag";
import RequestForm from "../form/RequestForm.vue";

export default {
  components: {
    RequestForm
  },
  data() {
    return {
      matcherRequest: {
        title: null,
        vacancyID: null,
        companyID: null,
        section: null,
        category: null,
        companyContactPartnerID: null,
        consultantID: null,
        userID: null,
        userGroupID: null,
        startsOn: null,
        duration: null,
        language: null,
        query: {
          fields: [],
          fieldGroups: []
        },
        vacancyTemplate: {
          occupationId: null,
          occupationString: null,
          takeOverOption: null,
          hoursPerWeek: null,
          salary: null,
          workTimes: null
        },
        favourites: [],
        favouritesAddresses: []
      }
    };
  },
  watch: {
    matcherRequest(value) {
      console.log(value);
    }
  },
  methods: {
    submit(model) {
      delete model["favourites"];
      delete model["favouritesAddresses"];
      const variables = {
        input: Object.deleteIdsAndTypes(model),
        id: this.$route.params.id
      };
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($input: MatcherRequestInput!, $id: ID!) {
              updateMatcherRequest(input: $input, id: $id) {
                id
              }
            }
          `,
          variables
        })
        .then(() => this.$apollo.queries.matcherRequest.refetch())
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Anfrage gespeichert",
            text: "Die Änderungen wurden gespeichert"
          });
        });
    },
    addFavourite(data) {
      const variables = {
        applicant: data.applicant.id,
        request: this.matcherRequest.id
      };
      this.$apollo.mutate({
        mutation: gql`
          mutation addApplicantToFavourites($request: ID!, $applicant: ID!) {
            addApplicantToFavourites(request: $request, applicant: $applicant) {
              id
            }
          }
        `,
        variables
      });
    },
    removeFavourite(data) {
      const variables = {
        applicant: data.applicant.id,
        request: this.matcherRequest.id
      };
      this.$apollo.mutate({
        mutation: gql`
          mutation RemoveApplicantFromFavourites(
            $request: ID!
            $applicant: ID!
          ) {
            removeApplicantFromFavourites(
              request: $request
              applicant: $applicant
            ) {
              id
            }
          }
        `,
        variables
      });
    }
  },
  apollo: {
    matcherRequest: {
      query: gql`
        query MatcherRequest($id: ID!) {
          matcherRequest(id: $id) {
            id
            vacancyID
            title
            companyID
            consultantID
            section
            category
            userID
            userGroupID
            language
            duration
            startsOn
            companyContactPartnerID
            query {
              id
              fields {
                id
                name
                term {
                  id
                  queryType
                  numericValue
                  stringValue
                  minNumericValue
                  maxNumericValue
                }
              }
              fieldGroups {
                id
                name
                fields {
                  id
                  name
                  term {
                    id
                    queryType
                    numericValue
                    stringValue
                    minNumericValue
                    maxNumericValue
                  }
                }
              }
            }
            vacancyTemplate {
              id
              occupationId
              occupationString
              takeOverOption
              holidayAndChristmasBonus
              salary
              hoursPerWeek
              workTimes
            }
            favourites {
              id
              occupationField {
                id
                name
              }
              firstName
              lastName
            }
            favouritesAddresses {
              city
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      fetchPolicy: "no-cache"
    }
  }
};
</script>
